module.exports = __webpack_public_path__ + "img/IMG_8512_P_L_WoodMatted_MockedUp.f0652b6a.jpg";